import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import axios from 'axios';

const BASE_URL =
	window.location.hostname === 'localhost' ? 'http://localhost:8000' : 'https://dlqw5ngx5xpnk.cloudfront.net';

const AdminResetPassword = () => {
	const [form, setForm] = useState({
		firstName: '',
		lastName: '',
		password: '',
		confirmPassword: '',
	});
	const [status, setStatus] = useState('');
	const [error, setError] = useState('');
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const location = useLocation();

	// Get token from URL
	const params = new URLSearchParams(location.search);
	const token = params.get('token');

	// Check if this is admin reset password
	const isAdmin = location.pathname.includes('/admin');

	// Decode token to prefill first and last name
	React.useEffect(() => {
		if (token) {
			try {
				// Decode JWT token to get user info (without verification since we'll verify on backend)
				const base64Url = token.split('.')[1];
				const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
				const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
					return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
				}).join(''));
				
				const decoded = JSON.parse(jsonPayload);
				
				// Prefill first and last name from token
				if (decoded.firstName || decoded.lastName) {
					setForm(prevForm => ({
						...prevForm,
						firstName: decoded.firstName || '',
						lastName: decoded.lastName || ''
					}));
				}
			} catch (err) {
				console.error('Error decoding token:', err);
				// Continue without prefilling names
			}
		}
	}, [token]);

	const handleChange = (e) => {
		setForm({ ...form, [e.target.name]: e.target.value });
		setError('');
		setStatus('');
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setError('');
		setStatus('');
		// Validation
		if (!form.firstName) {
			setError('First name is required');
			return;
		}
		if (!form.password || !form.confirmPassword) {
			setError('Both fields are required');
			return;
		}
		if (form.password !== form.confirmPassword) {
			setError('Passwords do not match');
			return;
		}
		if (!token) {
			setError('Invalid or expired reset link.');
			return;
		}
		setLoading(true);
		try {
			const endpoint = isAdmin ? `${BASE_URL}/api/admin/reset-password` : `${BASE_URL}/api/auth/reset-password`;
			const res = await axios.post(endpoint, {
				token,
				password: form.password,
				firstName: form.firstName,
				lastName: form.lastName,
			});
			if (res.data.success) {
				setStatus('Password reset successful! You can now log in.');
				setTimeout(() => navigate(isAdmin ? '/admin/login' : '/login'), 2000);
			} else {
				setError(res.data.message || 'Reset failed');
			}
		} catch (err) {
			setError(err.response?.data?.message || err.message || 'Reset failed');
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="container">
			<Row>
				<Col xl="12">
					<h2 className="personalinfo_head2">Reset Password</h2>
				</Col>
			</Row>
			<Row className="justify-content-center">
				<Col xl="4" >
					<div className="formbg">
						<h3>Reset Password</h3>
						<form onSubmit={handleSubmit}>
							{/* Add First Name */}
							<div className="form-floating mb-3">
								<input
									type="text"
									className="form-control form_custom"
									id="firstName"
									placeholder="Enter First Name"
									name="firstName"
									value={form.firstName}
									onChange={handleChange}
									required
								/>
								<label htmlFor="firstName">
									First Name <span className="text-danger">*</span>
								</label>
							</div>

							{/* Add Last Name */}
							<div className="form-floating mb-3">
								<input
									type="text"
									className="form-control form_custom"
									id="lastName"
									placeholder="Enter Last Name"
									name="lastName"
									value={form.lastName}
									onChange={handleChange}
								/>
								<label htmlFor="lastName">
									Last Name <span className="text-danger">*</span>
								</label>
							</div>
							<div className="form-floating mb-3 mt-3">
								<input
									type="password"
									className="form-control form_custom"
									id="password"
									placeholder="Enter New Password"
									name="password"
									value={form.password}
									onChange={handleChange}
									required
								/>
								<label htmlFor="password">
									New Password <span className="text-danger">*</span>
								</label>
							</div>
							<div className="form-floating mb-3 mt-3">
								<input
									type="password"
									className="form-control form_custom"
									id="confirmPassword"
									placeholder="Confirm New Password"
									name="confirmPassword"
									value={form.confirmPassword}
									onChange={handleChange}
									required
								/>
								<label htmlFor="confirmPassword">
									Confirm Password <span className="text-danger">*</span>
								</label>
							</div>
							<button className="login_btn" type="submit" disabled={loading}>
								{loading ? 'Resetting...' : 'Reset Password'}
							</button>
							{error && <div style={{ color: 'red', marginTop: 10 }}>{error}</div>}
							{status && <div style={{ color: 'green', marginTop: 10 }}>{status}</div>}
						</form>
					</div>
				</Col>
			</Row>
		</div>
	);
};

export default AdminResetPassword;
